import {
  ExecutionMethodNames,
  ExecutionMethodsDictionary,
} from '@wix/editor-platform-host-integration-apis';

const store = new Map<
  ExecutionMethodNames,
  ExecutionMethodsDictionary[ExecutionMethodNames]
>();

const setExecutionMethod = <K extends ExecutionMethodNames>(
  methodName: K,
  method: ExecutionMethodsDictionary[K],
) => {
  store.set(methodName, method);
};

const getExecutionMethod = <K extends ExecutionMethodNames>(
  methodName: K,
): ExecutionMethodsDictionary[K] | null => {
  const method = store.get(methodName);
  return method ? (method as ExecutionMethodsDictionary[K]) : null;
};

const contributeExecutionMethods = (
  methods: Partial<ExecutionMethodsDictionary>,
) => {
  (
    Object.entries(methods) as [
      ExecutionMethodNames,
      ExecutionMethodsDictionary[ExecutionMethodNames],
    ][]
  ).forEach(([methodName, method]) => {
    setExecutionMethod(methodName, method);
  });
};

export const ActionExecutionStore = {
  setExecutionMethod,
  getExecutionMethod,
  contributeExecutionMethods,
};
